import styled from 'styled-components';

export default styled.div`
  color: ${(props) => props.theme.colors.primary};
  font-size: 12px;
`;
